<template>
  <div
    class="is-flex is-align-items-center is-justify-content-space-around modal-height">
    <div>
      <button
        class="button is-info is-outlined button-width"
        @click="normalBreak">
        הפסקה
      </button>
    </div>
    <div>
      <button
        class="button is-info is-outlined button-width"
        @click="lunchBreak">
        הפסקת צהריים
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'BreakStartModal',
  props: {
    alert: {
      type: Object
    }
  },
  methods: {
    ...mapMutations('modals', ['create', 'removeModalById']),
    normalBreak () {
      this.statCreation('break_start').then(() => {
        this.openBreakModal('Break', '#009BEA', 'break_end')
        this.removeModalById(this.$attrs.payload.modal_id)
      })
    },
    lunchBreak () {
      this.statCreation('lunch_break_start').then(() => {
        this.openBreakModal('Lunch break', '#97F821', 'lunch_break_end')
        this.removeModalById(this.$attrs.payload.modal_id)
      })
    },
    statCreation (designator) {
      return this.$network_utils.postStat({
        resource_type: 'Admin',
        resource_id: this.$utils.getOwner().id,
        designator,
        title: designator
          .replace('_', ' ')
          .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase()),
        owner: this.$utils.getOwner().name
      })
    },
    openBreakModal (title, color, designator) {
      this.create({
        designator: 'break-status-modal',
        component_name: 'BreakStatusModal',
        modal_title: title,
        show_close_button: false,
        ignore_escape_button: true,
        is_center_modal: true,
        modal_width: 1500,
        props: {
          buttonTitle: 'סיום הפסקה',
          bgColor: color,
          statDesignator: designator,
          alertId: this.alert.id
        }
      })
    }
  }
}
</script>

<style scoped>
.button-width {
  width: 180px;
}
.modal-height {
  height: 200px;
}
</style>
